import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

export type AsideSectionProps = {
  title: string;
  children?: ReactNode;
  noGap?: boolean;
};

/**
 * Record sidebar section, Gravun style: small uppercase muted label over the
 * content, closed by a subtle border. Shared by contact/company/deal record
 * pages, keep the API stable.
 */
export function AsideSection({ title, children, noGap }: AsideSectionProps) {
  const isMobile = useIsMobile();
  return (
    <div className="mb-5 border-b border-border-subtle pb-5 text-sm last:mb-0 last:border-0 last:pb-0">
      <h3
        className={
          isMobile
            ? "text-lg font-semibold"
            : "pb-2 text-[10.5px] font-semibold uppercase tracking-[0.09em] text-muted-foreground"
        }
      >
        {title}
      </h3>
      <div className={cn("flex flex-col", { "gap-1": !noGap })}>{children}</div>
    </div>
  );
}
